import { observer } from 'mobx-react-lite'
import React, { useMemo } from 'react'
import Dropzone from 'react-dropzone'
import { toastError } from './Toasts'

export default observer(function FileDropzone({
  acceptedFileTypes = {},
  maxFiles = 1,
  uploadFiles,
  disabled,
  extraText,
  icon,
  backgroundColor = 'bg-rb-grey',
  borderColor = 'border-rb-dash-border',
  isCompact,
  hintText = '(PDF, PNG, JPG, GIF up to 4MB)',
}) {

  const typeErrorMessage = useMemo(() => {
    return Object.values(acceptedFileTypes).reduce((result, extensions, index) => {

      result += ' ' + extensions.join(', ').replaceAll('.', '')
      result += Object.keys(acceptedFileTypes).length - 1 == index ? '.' : ','
      return result
    }, 'Incorrect file type, accepted types are')
  }, [acceptedFileTypes])

  const notifyTypeError = () => toastError(typeErrorMessage, { autoClose: 5000 })

  return (
    <Dropzone
      accept={acceptedFileTypes}
      maxFiles={maxFiles}
      onDropAccepted={uploadFiles}
      onDropRejected={notifyTypeError}
      disabled={disabled}
      noDragEventsBubbling={true}
    >
      {({getRootProps, getInputProps}) => (
        <div className={`border border-dashed cursor-pointer rounded-lg h-full ${backgroundColor} ${borderColor} dark:bg-rb-dark-mode dark:border-rb-dark-mode-lighter`}>
          <div className={`flex items-center justify-center ${isCompact ? 'p-2' : 'w-full h-full p-4'}`} {...getRootProps()}>
            <input {...getInputProps()} />
            <div className="font-semibold text-rb-green flex flex-col items-center justify-center">
              <span className={`${isCompact ? '': 'mr-2 mb-2'} text-3xl`}>
                <span className="dark:text-rb-dark-mode-text-grey text-rb-mat-grey">{icon}</span>
              </span>
              {
                !isCompact && (
                  <>
                    <span className='text-center'>
                      <span className='font-bold text-rb-green dark:text-rb-green mr-1'>Upload a file</span>
                      <span className= 'dark:text-rb-dark-mode-text-grey text-rb-mat-grey' >or drag and drop</span>
                    </span>
                    {Array.isArray(hintText) ? (
                      <span className='flex flex-wrap justify-center gap-1 mt-1 max-w-[280px]'>
                        {hintText.map(format => (
                          <span
                            key={format}
                            className='px-1.5 py-0.5 rounded border border-rb-widget-border dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode-lighter text-[10px] font-medium text-rb-mat-grey dark:text-rb-dark-mode-text-grey'
                          >
                            {format}
                          </span>
                        ))}
                      </span>
                    ) : (
                      <span className='dark:text-rb-dark-mode-text-grey text-rb-mat-grey text-xs' >{hintText}</span>
                    )}
                  </>
                )
              }
            </div>
            <p className="text-rb-green-o-40 text-xs dark:text-rb-dark-mode-text-grey">{extraText}</p>
          </div>
        </div>
      )}
    </Dropzone>
  )
})
